export default {
  methods: {
    $featureEnabled(feature) {
      return this.$store.getters['features/isEnabled'](feature)
    }
  }
}
